import React, {Component, Fragment} from 'react'
import StyleSheet from 'styles'
import {withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import { CountryActions, DocumentActions } from 'actionsets'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import FormMixin from 'containers/shared/FormMixin'
import CenteredContent from 'containers/CenteredContent'
import {StyledForm} from 'components'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { MarkDownField } from 'components/MarkdownField'
import Checkbox from 'components/styled/Checkbox'
import {FormContext} from 'components'
import {uuid} from 'utils'
import DeleteIcon from '@material-ui/icons/Delete'
import {IconButton} from 'components/OptimisedMui'
import Collapse from '@material-ui/core/Collapse'
import Preview from './Preview'
import {InfoDialog} from 'components'

export class Form extends FormMixin(Component){

  constructor(props){
    super(props)
    CountryActions.bindActions(this)
    DocumentActions.bindActions(this, 'documents')
    this.onSaveRoute = '/countries'
  }

  get formObject(){
    return this.props.country.id ? this.props.country : {
      certificationItems: [{key: uuid()}],
      defaultDownloads: [{key: uuid(), tag: 'support'}, {key: uuid(), tag: 'aml'}]
    }
  }

  get errorContext(){
    return (this.props.errors[this.saveActionName] || {}).meta
  }

  dependsOn(){
    this.actions.documents.show({name: 'risk_disclaimer'})
    return super.dependsOn()
  }

  handleAddCriteria = () => {
    const attributes = this.updatedFormObject
    this.setState({attributes: {...attributes, certificationItems: [...attributes.certificationItems, {key: uuid()}]}})
  }

  handleDeleteCriteria = item => () => {
    const attributes = this.updatedFormObject
    this.setState({attributes: {...attributes, certificationItems: attributes.certificationItems.filter(i => i !== item)}})
  }

  handlePreview = () => {
    this.setState({showPreview: true})
  }

  handleClosePreview = () => {
    this.setState({showPreview: false})
  }

  render = () =>
    <CenteredContent>

        <StyledForm style={{maxWidth: 553}}>
          <FormContext
            context={this.updatedFormObject}
            onChange={attributes => this.setState({attributes})}
            errorContext={this.errorContext}
          >
            <div className={styles.section}>
              <Typography variant="h5">Edit Country</Typography>
              <TextField member='name' autoFocus={true} fullWidth={false}/>
              <TextField member='continent' fullWidth={false}/>
              <TextField member='iso2' fullWidth={false}/>
              <TextField member='iso3' fullWidth={false}/>
              <TextField member='internet' fullWidth={false}/>
              <TextField member='telephone' fullWidth={false}/>
              <Typography style={{display: 'inline-block'}}>
                <Checkbox member="supported" style={{marginLeft: -12}}/> Supports on platform investment
              </Typography>
            </div>

            <Collapse in={!this.updatedFormObject.supported}>
              <div className={styles.section}>
                <Typography variant='h6'>Unsupported Message</Typography>
                <MarkDownField label='Message' member='unsupportedMessage' showPreviewButton={false}/>
              </div>
            </Collapse>

            <Collapse in={this.updatedFormObject.supported}>
              <div className={styles.section}>
                <Typography variant='h6'>Disclaimer</Typography>
                <MarkDownField label='Disclaimer' member='disclaimer' showPreviewButton={false}/>
              </div>

              <div className={styles.section}>
                <Typography variant='h6'>Investor Certification</Typography>
                <TextField member='certificationHeading' label="Heading" fullWidth={false}/>
                <MarkDownField label='Preamble' member='certificationPreamble' showPreviewButton={false}/>
                {this.updatedFormObject.certificationItems.map((item, i) =>
                  <Fragment key={i}>
                    <IconButton style={{float: 'right', marginTop: 13, marginBottom: -15}}
                                onClick={this.handleDeleteCriteria(item)}>
                      <DeleteIcon/>
                    </IconButton>
                    <Typography variant="subtitle1">Criteria</Typography>
                    <MarkDownField label='Question' member={`certificationItems[${i}].question`}
                                   showPreviewButton={false}/>
                    <Typography>
                      <Checkbox member={`certificationItems[${i}].requireAttachment`}
                                style={{marginLeft: -12}}/> Require Attachment
                    </Typography>
                  </Fragment>
                )}
              </div>

              <div className={styles.section}>
                <Button className={styles.addButton} onClick={this.handleAddCriteria}>Add Another Criteria</Button>
              </div>
            </Collapse>
          </FormContext>

          <div className={styles.buttons}>
            <Button onClick={this.handlePreview} variant='contained' color='secondary'>Preview</Button>
            <Button onClick={this.save} variant='contained' color='primary'>Save</Button>
          </div>

          <InfoDialog open={this.state.showPreview} onClose={this.handleClosePreview}>
            <StyledForm>
              <Preview country={this.updatedFormObject} riskDisclaimer={this.props.riskDisclaimer}/>
            </StyledForm>
          </InfoDialog>
        </StyledForm>
    </CenteredContent>
}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column'
  },
  card: {
    flex: '0 1',
    minWidth: 300,
    alignSelf: 'flex-start',
    margin: 10,
    maxWidth: 1200
  },
  actions: {
    display: 'flex',
    justifyContent: 'end'
  },
  section: {
    marginBottom: 50,
    position: 'relative'
  },
  addButton: {
    backgroundColor: '#b9b39b',
    color: 'white',
    width: 'calc(100% - 10px)',
    marginBottom: 20,
    '&:hover': {
      backgroundColor: '#c2bca4',
    }
  },
  buttons: {
    display: 'flex',
    '& button': {
      flex: 1,
      marginRight: 10,
    }
  }
})

export default connect(({countries, documents}) => ({...documents, ...countries}))(withRouter(Dependent({loader: true, wrapperClassName: styles.wrapper})(Form)))